import { useSettingsStore } from "@/store/settings"

export default function noProfile({next, router}: {next: any, router: any}) {
  const { profile } = useSettingsStore()
    if (profile)
        return router.push('/')
    return next()
}
